import React from "react";
import { useI18n } from "Hooks";

import {
  Dropdown,
  IconDisclosure,
  DropdownMenu,
  Tooltip,
  IconButton,
} from "@toddle-edu/ds-web";
import { getModuleLevelAccessOptions } from "StaffPermissions/modules/utils";
import { EyeHiddenOutlined } from "@toddle-edu/ds-icons";
import classes from "./BulkApplyModuleAccessLevel.scss";

const styles = {
  overlayInnerStyle: {
    maxWidth: "240px",
    textAlign: "center",
  },
};

const BulkApplyColumnAction = props => {
  const { column, behaviourNomenclatureConstants } = props;
  const {
    metadata: { curriculumAcronym = "", curriculumType } = {},
    id: module,
    applyBulkUpdate,
    isDisabled,
  } = column;
  const { t } = useI18n();

  const moduleAccessOptions = getModuleLevelAccessOptions({
    t,
    module,
    curriculumAcronym,
    curriculumType,
    behaviourNomenclatureConstants,
  });

  const label = (
    <div className={classes.headerText}>{t("common:bulk_apply")}</div>
  );

  const moduleAccessBulkApplyItemGroup = [
    {
      isItemGroup: true,
      key: "BULK_APPLY",
      label: label,
      options: moduleAccessOptions,
    },
  ];

  const handleAccessSelect = ({ key }) => {
    applyBulkUpdate(key);
  };

  return (
    <>
      {isDisabled ? (
        <Tooltip
          tooltip={t("common:staff_permission_disable_module", {
            curriculum: curriculumAcronym,
          })}
          placement="bottom"
          overlayInnerStyle={styles.overlayInnerStyle}
        >
          <IconButton
            icon={<EyeHiddenOutlined variant="on" />}
            variant="dark"
            size="medium"
          />
        </Tooltip>
      ) : null}
      <Dropdown
        disabled={isDisabled}
        overlay={
          <DropdownMenu
            options={moduleAccessBulkApplyItemGroup}
            onClick={handleAccessSelect}
            hasMultilineOptions
            itemTitleContainerStyle={{
              maxWidth: "320px",
              whiteSpace: "normal",
            }}
          />
        }
        placement={"bottomRight"}
      >
        <IconDisclosure variant="dark" />
      </Dropdown>
    </>
  );
};

export default BulkApplyColumnAction;
